import { render, staticRenderFns } from "./MailInhalt.vue?vue&type=template&id=3156a9d9"
import script from "./MailInhalt.vue?vue&type=script&lang=js"
export * from "./MailInhalt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports